import { memo } from 'react';
import { ModalBody, ModalContent, Modal, ModalHeader, ModalFooter } from '@heroui/react';
import { AppButton } from '@/shared/ui/AppButton';
import { useBodyOverflow } from '@/shared/lib/components/FloatingProvider';
import { scaleInOut } from '@/shared/lib/utils/modalTransitions';
import styles from './MessageModal.module.scss';

interface CustomModalProps {
  isOpen: boolean;
  onOpenChange: () => void;
  confirmText: string;
  title?: string;
  text?: string;
  variant: 'black' | 'red';
  toggleVisibility?: () => void;
  isLoading?: boolean;
}

export const MessageModal = memo((props: CustomModalProps) => {
  const {
    title,
    text,
    onOpenChange,
    isOpen,
    confirmText,
    variant,
    isLoading = false,
    toggleVisibility,
  } = props;

  useBodyOverflow({ elementId: 'message-modal', condition: isOpen, unlockOnUnmount: true });

  return (
    <Modal
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      placement="center"
      motionProps={scaleInOut}
      size="md"
      shouldBlockScroll={false}
      classNames={{
        base: 'p-5 flex flex-col max-w-[504px]',
        closeButton: styles.closeBtn,
      }}
    >
      <ModalContent>
        {(onClose) => (
          <>
            <ModalHeader className={styles.title}>{title}</ModalHeader>
            <ModalBody className="p-0">
              <div className="flex flex-col">
                <p className={styles.text}>{text}</p>
              </div>
            </ModalBody>
            <ModalFooter className="flex justify-center items-center gap-4 p-0 mt-6">
              <AppButton color="white" onPress={onClose}>
                Cancel
              </AppButton>
              <AppButton
                onPress={toggleVisibility}
                color={variant === 'black' ? 'black' : 'red'}
                className={variant !== 'black' ? 'bg-[#900B09]' : ''}
                isLoading={isLoading}
              >
                {confirmText}
              </AppButton>
            </ModalFooter>
          </>
        )}
      </ModalContent>
    </Modal>
  );
});
